import {LocalizedContentValues} from '../types/GeneralSettingsFormValues';

export function isLocalizedEntryChanged(
  current: LocalizedContentValues,
  initial: LocalizedContentValues | undefined
): boolean {
  return (
    current.titleExtension !== (initial?.titleExtension ?? null) ||
    current.description !== (initial?.description ?? null)
  );
}
